import { RouteParams } from "@/hooks/useRouteParams";

const defaultFilter = [
  "search-term",
  "sortBy",
  "page",
  "facet",
  "cardSize",
  "listHead",
  "lolcode",
  "plpView",
  "price",
  "priceBands",
  "chunk",
];

const foundItFilter = [
  ...defaultFilter,
  "fi", // FoundIt param for analytics
  "fic", // FoundIt curation experiment param
];

export const validateQueryParams = (query: RouteParams["query"]) => {
  return Object.entries(query).reduce(
    (acc, [key, value]) => {
      if (typeof value === "string" && foundItFilter.includes(key)) {
        acc[key] = value;
      }
      return acc;
    },
    {} as Record<string, string>,
  );
};
